import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { capitalize } from 'lodash';
import { CheckLg as EnabledIcon, XLg as DisabledIcon, Dash as UnavailableIcon } from 'react-bootstrap-icons';
import { useGradYearSelectability } from '../hooks/use-grad-year-selectability';

const GradYearToggle = ({
    gradYear
}) => {
    const {
        getGradYearLabel,
        isGradYearSelected,
        setGradYearSelected,
        canAlterGradYearSelection
    } = useGradYearSelectability();
    const disabled = !canAlterGradYearSelection(gradYear);
    const isSelected = !disabled && isGradYearSelected(gradYear);
    const pluralLabel = capitalize((getGradYearLabel(gradYear) || {})?.plural || 'unknown');
    const title = `${isSelected ? `Deselect All` : `Select All`} ${pluralLabel}`;
    const Icon = disabled ? UnavailableIcon : isSelected ? EnabledIcon : DisabledIcon;
    const backgroundColor = !disabled ? 'transparent' : 'rgba(0,0,0,0.1)';
    return (
        <Dropdown.Item
            title={title}
            onClick={() => setGradYearSelected(gradYear, !isSelected)}
            disabled={disabled}
            style={{ backgroundColor }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px'}}>
            <Icon /> <span>{title} ({gradYear})</span>
            </div>
        </Dropdown.Item>
    )
}

export const GradeSelectionDropdown = () => {
    const { gradYears, selectAll, deselectAll } = useGradYearSelectability();
    return (
        <DropdownButton
            variant="outline-secondary"
            title="Select / Deselect"
            id="input-group-dropdown-2"
            align="end"
        >
            {gradYears.map(gradYear => (<GradYearToggle key={gradYear} gradYear={gradYear} />))}
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => selectAll()} >Select All</Dropdown.Item>
            <Dropdown.Item onClick={() => deselectAll()} >Deselect All</Dropdown.Item>
        </DropdownButton>
    );
};
